var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.25 8.25 21 12m0 0-3.75 3.75M21 12H3","stroke":"#fff","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ArrowRight.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
